import { useQueryClient } from 'react-query';

import { KEYS } from 'helpers/react-query.config';

const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateQueries = async (ticketId: number) => {
    await Promise.all([
      queryClient.invalidateQueries(KEYS.ticket.tickets.detail(ticketId)),
      queryClient.invalidateQueries(KEYS.ticket.logbook.list()),
      queryClient.invalidateQueries(KEYS.ticket.tickets.getAvailableStatuses()),
      queryClient.invalidateQueries(KEYS.ticket.tickets.generalSearch())
    ]);
  };

  return {
    invalidateQueries
  };
};

export default useInvalidateQueries;
